import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-licensedetails',
  templateUrl: './licensedetails.component.html',
  styleUrls: ['./licensedetails.component.scss']
})
export class LicensedetailsComponent implements OnInit {

  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  Status: boolean = false;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  isShownadBtn: Boolean = false;
  isShownupdBtn: Boolean = true;
  imageurl: string;
  LicType: string;
  LicenseName: string;
  LicenseNumber: string;
  LicenseDate: string;
  ValidFrom: string;
  ValidTo: string;
  LicCurrency: string;
  LicValue: string;
  ItemNo: string;
  partsId: string;
  PartName: string;
  ItemUnit: string;
  ItemUnitWeight: string;
  ItemUnitPrice: string;
  ItemQuantity: string;
  ItemUnitValue: string;
  Description: string;
  Parts = [] as any;
  AdmCurrency = [] as any;
  LicItems = [] as any;
  myFiles: string[] = [];
  surl: string;
  isShownimage: boolean = true;
  selects = [] as any;
  isShowndoclist: boolean = true;
  public searchText: string;
  licenseExport = [] as any;
  Editedlicense = [] as any;
  EditedlicenseId: string;
  Editedlicensepart = [] as any;
  EditedlicensepartId: string;
  updatedocid = [] as any;
  EditedDoc = [] as any;
  slicId: string;

  @ViewChild('file')
  myInputVariable: ElementRef;

  displayedColumns1: string[] = ['sno', 'type', 'number', 'licenseDate1', 'validFrom1', 'validTo1', 'currency', 'value', 'status'];
  dataSource1: MatTableDataSource<any[]>;
  @ViewChild('paginator1', { static: true }) paginator1: MatPaginator;
  @ViewChild('sort1', { static: true }) sort1: MatSort;
  @ViewChild('TABLE1') table2: ElementRef;

  displayedColumnsItem: string[] = ['sno', 'itemnum', 'partnumber', 'partname', 'unit', 'unitWeight', 'unitPrice', 'quantity', 'value'];
  dataSourceItem: MatTableDataSource<any[]>;
  @ViewChild('TableItemPaginator', { static: true }) tableItemPaginator: MatPaginator;
  @ViewChild('TableItemSort', { static: true }) tableItemSort: MatSort;
  @ViewChild('TABLE1') table1: ElementRef;
  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.partsId = "0";
    this.LicType = "0";
    this.BindLicenseGrid();
    this.BindPartsDDL();
    this.BindCurrencyDDL();
    this.BindlicenseExport();

  }
  ngAfterViewInit(): void {

  }
  BindPartsDDL() {
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/GetPartsForDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.Parts = data;
          this.partsId = "0";
        }
        else {
          this.partsId = "0";
        };
      });
  }
  BindCurrencyDDL() {
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/GetCurrencyForDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.AdmCurrency = data;
          //this.LicCurrency = "0";
        }
        else {
          //this.LicCurrency = "0";
        };
      });
  }


  btnAddClick() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    if (this.ItemNo == undefined || this.ItemNo == null || this.ItemNo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Number.";
      return false;
    }
    if (this.partsId == undefined || this.partsId == null || this.partsId == "" || this.partsId == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Part Number.";
      return false;
    }
    if (this.PartName == undefined || this.PartName == null || this.PartName == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Part Name.";
      return false;
    }
    if (this.ItemUnit == undefined || this.ItemUnit == null || this.ItemUnit == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Unit.";
      return false;
    }
    if (this.ItemUnitWeight == undefined || this.ItemUnitWeight == null || this.ItemUnitWeight == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Unit Weight.";
      return false;
    }
    if (this.ItemUnitPrice == undefined || this.ItemUnitPrice == null || this.ItemUnitPrice == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Unit Price.";
      return false;
    }
    var vUnitPrice=this.ItemUnitPrice;
    if(Number(vUnitPrice)<1){
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid Unit Price.";
      return false;
    }
    if (this.ItemQuantity == undefined || this.ItemQuantity == null || this.ItemQuantity == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Quantity.";
      return false;
    }
    var vItemQuantity=this.ItemQuantity;
    if(Number(vItemQuantity)<1){
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid Item Quantity.";
      return false;
    }
    if (this.ItemUnitValue == undefined || this.ItemUnitValue == null || this.ItemUnitValue == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Value.";
      return false;
    }
    var vItemUnitValue=this.ItemUnitValue;
    if(Number(vItemUnitValue)<1){
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid Item Value.";
      return false;
    }
    debugger;
    var editedlicId = this.EditedlicenseId;
    if(editedlicId!=undefined && editedlicId != "0" && editedlicId != null )
    { 
      var vitemnum = this.ItemNo;
      var vpartnum = this.partsId;
      var vpartname = this.PartName;
      var vunit = this.ItemUnit;
      var vunitweight = this.ItemUnitWeight;
      var vunitPrice = this.ItemUnitPrice;
      var vquantity = this.ItemQuantity;
      var vvalue = this.ItemUnitValue;
      let params4 = new HttpParams();
      params4 = params4.append('slicId', editedlicId);
      params4 = params4.append('nitemnum', vitemnum);
      params4 = params4.append('npartnum', vpartnum);
      params4 = params4.append('npartname', vpartname);
      params4 = params4.append('nunit', vunit);
      params4 = params4.append('nunitweight', vunitweight);
      params4 = params4.append('nunitPrice', vunitPrice);
      params4 = params4.append('nquantity', vquantity);
      params4 = params4.append('nvalue', vvalue);
      debugger;
      var value = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicensepart', { params: params4 }).toPromise().then(
        (data: any) => {
          var vmsg = data;
          this.BindLicensepartGrid();
          this.btnpartclear();
        }).catch((data: any) => {
          var vmsg = data;
          this.BindLicensepartGrid();
          this.btnpartclear();
        });
    
  }
  else{
    debugger;
    this.LicItems.push({ itemnum: this.ItemNo, partnumber: this.partsId, partname: this.PartName, unit: this.ItemUnit, unitWeight: this.ItemUnitWeight, unitPrice: this.ItemUnitPrice, quantity: this.ItemQuantity, value: this.ItemUnitValue, licenseItemId: this.EditedlicensepartId });
    debugger;
    this.dataSourceItem = new MatTableDataSource(this.LicItems);
    this.dataSourceItem.data = this.LicItems;
    this.dataSourceItem.paginator = this.tableItemPaginator;
    this.dataSourceItem.sort = this.tableItemSort;
  }
    this.ItemNo = "";
    this.partsId = "0";
    this.PartName = "";
    this.ItemUnit = "";
    this.ItemUnitWeight = "";
    this.ItemUnitPrice = "";
    this.ItemQuantity = "";
    this.ItemUnitValue = "";
  }

  public uploadFile = (files) => {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    debugger;
    if (files.length == 0) {
      return;
    }
    for (var i = 0; i < files.length; i++) {
      this.myFiles.push(files[i]);
    }
    const formData = new FormData();
    for (var i = 0; i < this.myFiles.length; i++) {
      formData.append("file[]", this.myFiles[i]);
    }
    this.http.post(environment.apiUrl + 'LicenseAdm/UploadContent', formData).subscribe(
      (response) => {
        debugger;
        alert(response);
      },
      (error) => {
        debugger;
        var vDataError = JSON.stringify(error.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        this.surl = vErrorMsg1;
        var spliturl = vErrorMsg1.split(",");
        for (var i = 0; i < spliturl.length; i++) {
          this.isShownimage = false;
          this.isShowndoclist = false;
          var furl = spliturl[i];
          var cvname = furl.split("/");
          var fname = cvname[6];
          this.selects.push({ filename: fname, fileURL: furl });
          this.imageurl = furl;
          this.isShownSuccess = false;
          this.SuccessMsg = "File Uploaded"
          this.myFiles = [];
          this.myInputVariable.nativeElement.value = "";
        }
      }
    )

  }
  SaveLicenseInfo() {
    if (this.LicType == undefined || this.LicType == null || this.LicType == "" || this.LicType == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select License Type.";
      return false;
    }
    if (this.LicenseName == undefined || this.LicenseName == null || this.LicenseName == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Name.";
      return false;
    }
    if (this.LicenseNumber == undefined || this.LicenseNumber == null || this.LicenseNumber == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Number.";
      return false;
    }
    if (this.LicenseDate == undefined || this.LicenseDate == null || this.LicenseDate == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Date.";
      return false;
    }
    if (this.ValidFrom == undefined || this.ValidFrom == null || this.ValidFrom == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid From.";
      return false;
    }
    if (this.ValidTo == undefined || this.ValidTo == null || this.ValidTo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid To.";
      return false;
    }
    if (this.ValidFrom > this.ValidTo) {
      this.isShownError = false;
      this.ErrorMsg = "Valid To Date Should be Geater Then or EqualTo Valid From Date.";
      return false;
    }
    if (this.LicCurrency == undefined || this.LicCurrency == null || this.LicCurrency == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Currency.";
      return false;
    }
    if (this.LicValue == undefined || this.LicValue == null || this.LicValue == "" || this.LicValue == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Value.";
      return false;
    }
    var vVal=this.LicValue;
    if(Number(vVal)<1){
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid Value.";
      return false;
    }
    if (this.Description == undefined || this.Description == null || this.Description == "" || this.Description == "0") {
      this.Description = "";
    }
    if(this.LicItems==undefined || this.LicItems==null || this.LicItems==[] || this.LicItems.length ==0)
    {
      this.isShownError = false;
      this.ErrorMsg = "Please Add Atleast One License Item.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('sType', this.LicType);
    params = params.append('sName', this.LicenseName);
    params = params.append('sNumber', this.LicenseNumber);
    params = params.append('dLicevseDate', this.LicenseDate);
    params = params.append('dValidFrom', this.ValidFrom);
    params = params.append('dValidTo', this.ValidTo);
    params = params.append('sCurrency', this.LicCurrency);
    params = params.append('dValue', this.LicValue);
    params = params.append('sDescription', this.Description);
    debugger;
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicense', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var licId = data;
        this.slicId = licId;

        var licensepart = this.LicItems;
        for (var i = 0; i < licensepart.length; i++) {
          var vlicense = licensepart[i];
          var vitemnum = vlicense.itemnum;
          var vpartnum = vlicense.partnumber;
          var vpartname = vlicense.partname;
          var vunit = vlicense.unit;
          var vunitweight = vlicense.unitWeight;
          var vunitPrice = vlicense.unitPrice;
          var vquantity = vlicense.quantity;
          var vvalue = vlicense.value;
          let params4 = new HttpParams();
          params4 = params4.append('slicId', this.slicId);
          params4 = params4.append('nitemnum', vitemnum);
          params4 = params4.append('npartnum', vpartnum);
          params4 = params4.append('npartname', vpartname);
          params4 = params4.append('nunit', vunit);
          params4 = params4.append('nunitweight', vunitweight);
          params4 = params4.append('nunitPrice', vunitPrice);
          params4 = params4.append('nquantity', vquantity);
          params4 = params4.append('nvalue', vvalue);
          debugger;
          var value = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicensepart', { params: params4 }).toPromise().then(
            (data: any) => {
              debugger;
              var strId1 = data;
            })
        }
        var spliturl = this.surl;
        debugger;
        if (spliturl != undefined && spliturl != "") {
          let params3 = new HttpParams();
          params3 = params3.append('sLicencenseId', this.slicId);
          params3 = params3.append('sfurl', spliturl);
          debugger;
          var value2 = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicenseDoc', { params: params3 }).toPromise().then(
            (data: any) => {
              this.LicType = "0";
              this.LicenseName = "";
              this.LicenseNumber = "";
              this.LicenseDate = "";
              this.ValidFrom = "";
              this.ValidTo = "";
              this.LicCurrency = "";
              this.LicValue = "";
              this.Description = "";
              this.Status = true;
              this.isShownSuccess = false;
              this.myFiles = [];
              this.LicItems = [];
              this.dataSourceItem = new MatTableDataSource(this.LicItems);
              this.dataSourceItem.data = this.LicItems;
              this.isShowndoclist = true;
              this.selects = [];
              this.surl="";
              this.SuccessMsg = "License Added.";
              this.BindLicenseGrid();
              return false;
            }).catch((data: any) => {
              debugger;
              this.LicType = "0";
              this.LicenseName = "";
              this.LicenseNumber = "";
              this.LicenseDate = "";
              this.ValidFrom = "";
              this.ValidTo = "";
              this.LicCurrency = "";
              this.LicValue = "";
              this.Description = "";
              this.Status = true;
              this.myFiles = [];
              this.selects = [];
              this.LicItems = [];
              this.surl="";
              this.dataSourceItem = new MatTableDataSource(this.LicItems);
              this.dataSourceItem.data = this.LicItems;
              this.isShowndoclist = true;
              this.isShownSuccess = false;
              this.SuccessMsg = "License Added.";
              this.BindLicenseGrid();
              return false;
            })
        }
        else {
          this.LicType = "0";
          this.LicenseName = "";
          this.LicenseNumber = "";
          this.LicenseDate = "";
          this.ValidFrom = "";
          this.ValidTo = "";
          this.LicCurrency = "";
          this.LicValue = "";
          this.Description = "";
          this.Status = true;
          this.myFiles = [];
          this.selects = [];
          this.LicItems = [];
          this.surl="";
          this.dataSourceItem = new MatTableDataSource(this.LicItems);
          this.dataSourceItem.data = this.LicItems;
          this.isShowndoclist = true;
          this.isShownSuccess = false;
          this.SuccessMsg = "License Added.";
          this.BindLicenseGrid();
        }
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "License Number, Already Exists.";
          return false;
        }
        else {
        }
      });
  }
  SaveLicense() {
    debugger;
    //"Content-Type": "application/json;charset=utf-8"
    //"Access-Control-Allow-Credentials": "true",
    var vdata = JSON.stringify(this.LicItems)
    this.http.post(environment.apiUrl + 'LicenseAdm/InsertLicItems', JSON.stringify(this.LicItems), {
      headers: {
        "Access-Control-Allow-Origin": "https://localhost:44384",
        "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,OPTIONS",
        "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,X-Access-Token,XKey,Authorization",
        "Access-Control-Max-Age": "86400"
      }
    }).subscribe(
      (response) => {
        debugger;
        alert(response);

      },
      (error) => {
        debugger;
        var vDataError = JSON.stringify(error.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        this.imageurl = vErrorMsg1;
        this.isShownSuccess = false;
        this.SuccessMsg = "File Uploaded"

      }
    )
  }

  Editlicdet(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.Status = true;
    this.isShownSuccess = true;
    this.isShownError = true;
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    this.Editedlicense = item;
    debugger;
    var vtype = this.Editedlicense.type;
    var vname = this.Editedlicense.name;
    var vnumber = this.Editedlicense.number;
    var vlicenseDate = this.Editedlicense.licenseDate;
    var vvalidFrom = this.Editedlicense.validFrom;
    var vvalidTo = this.Editedlicense.validTo;
    var vcurrency = this.Editedlicense.currency;
    var vvalue = this.Editedlicense.value;
    var vdescription = this.Editedlicense.description;
    var vstatus = this.Editedlicense.status;
    var vlicenseinfoid = this.Editedlicense.licenseinfoid;

    debugger;
    this.EditedlicenseId = vlicenseinfoid;
    this.LicType = vtype;
    this.LicenseName = vname;
    this.LicenseNumber = vnumber;
    this.LicenseDate = new Date(new Date(vlicenseDate).setDate(new Date(vlicenseDate).getDate() + 1)).toISOString().split('T')[0];
    this.ValidFrom = new Date(new Date(vvalidFrom).setDate(new Date(vvalidFrom).getDate() + 1)).toISOString().split('T')[0];
    this.ValidTo = new Date(new Date(vvalidTo).setDate(new Date(vvalidTo).getDate() + 1)).toISOString().split('T')[0];
    this.LicCurrency = vcurrency;
    this.LicValue = vvalue;
    this.Description = vdescription;
    if (vstatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
    debugger;
    var value5 = this.http.get(environment.apiUrl + 'LicenseAdm/GetlicPartForEdit?licId=' + vlicenseinfoid).toPromise().then(
      (data: any) => {
        debugger;
        if ((data.length != 0)) {
          var vData2 = data;
          this.dataSourceItem = new MatTableDataSource(vData2);
          this.dataSourceItem.data = vData2;
          this.dataSourceItem.paginator = this.tableItemPaginator;
          this.dataSourceItem.sort = this.tableItemSort;
        }
      });

    this.selects = [];
    var value3 = this.http.get(environment.apiUrl + 'LicenseAdm/GetDocForEdit?licId=' + vlicenseinfoid).toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          var vData1 = data;
          debugger;
          for (var i = 0; i < vData1.length; i++) {
            this.EditedDoc = vData1[i];
            var vdocId = this.EditedDoc.ldocId;
            var vdocurl = this.EditedDoc.docUrl;
            var furl = vdocurl;
            this.isShownimage = false;
            this.isShowndoclist = false;
            var cvname = furl.split("/");
            var fname = cvname[6];
            this.selects.push({ docid: vdocId, filename: fname, fileURL: furl });
            // this.updatedocid.push({ updocid: vdocId, upfileurl: furl });
            //var fdocid = this.updatedocid;                 
          }

        }
      });
  }


  Editlicense(item: any) {
    this.isShownadBtn = true;
    this.isShownupdBtn = false;
    this.Editedlicensepart = item;
    debugger;
    var vtype = this.Editedlicensepart.type;
    var vitemnum = this.Editedlicensepart.itemnum;
    var vpartnumber = this.Editedlicensepart.partnumber;
    var vpartname = this.Editedlicensepart.partname;
    var vunit = this.Editedlicensepart.unit;
    var vunitWeight = this.Editedlicensepart.unitWeight;
    var vunitPrice = this.Editedlicensepart.unitPrice;
    var vquantity = this.Editedlicensepart.quantity;
    var vvalue = this.Editedlicensepart.value;
    var vlicenseInfoId = this.Editedlicensepart.licenseInfoId;
    var vlicpartId = this.Editedlicensepart.licpartId;
    debugger;

    this.ItemNo = vitemnum;
    this.PartName = vpartname;
    this.partsId = vpartnumber;
    this.ItemUnit = vunit;
    this.ItemUnitWeight = vunitWeight;
    this.ItemUnitPrice = vunitPrice;
    this.ItemQuantity = vquantity;
    this.ItemUnitValue = vvalue;
    this.EditedlicenseId = vlicenseInfoId;
    this.EditedlicensepartId = vlicpartId;

  }

  btnUpdateClick() {
    var editedlicId = this.EditedlicenseId;
    var editedlicPartId = this.EditedlicensepartId;
    debugger;
    if (this.ItemNo == undefined || this.ItemNo == null || this.ItemNo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Number.";
      return false;
    }
    if (this.partsId == undefined || this.partsId == null || this.partsId == "" || this.partsId == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Part Number.";
      return false;
    }
    if (this.PartName == undefined || this.PartName == null || this.PartName == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Part Name.";
      return false;
    }
    if (this.ItemUnit == undefined || this.ItemUnit == null || this.ItemUnit == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Unit.";
      return false;
    }
    if (this.ItemUnitWeight == undefined || this.ItemUnitWeight == null || this.ItemUnitWeight == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Unit Weight.";
      return false;
    }
    if (this.ItemUnitPrice == undefined || this.ItemUnitPrice == null || this.ItemUnitPrice == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Unit Weight.";
      return false;
    }
    if (this.ItemQuantity == undefined || this.ItemQuantity == null || this.ItemQuantity == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Quantity.";
      return false;
    }
    if (this.ItemUnitValue == undefined || this.ItemUnitValue == null || this.ItemUnitValue == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Item Value.";
      return false;
    }
    // if(this.LicItems==undefined || this.LicItems==null || this.LicItems==[] || this.LicItems.length ==0)
    // {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Add Atleast One License Item.";
    //   return false;
    // }
    debugger;
    let params4 = new HttpParams();
    params4 = params4.append('slicId', editedlicId);
    params4 = params4.append('slicpartId', editedlicPartId);
    params4 = params4.append('nitemnum', this.ItemNo);
    params4 = params4.append('npartnum', this.partsId);
    params4 = params4.append('npartname', this.PartName);
    params4 = params4.append('nunit', this.ItemUnit);
    params4 = params4.append('nunitweight', this.ItemUnitWeight);
    params4 = params4.append('nunitPrice', this.ItemUnitPrice);
    params4 = params4.append('nquantity', this.ItemQuantity);
    params4 = params4.append('nvalue', this.ItemUnitValue);
    debugger;
    var value3 = this.http.get(environment.apiUrl + 'LicenseAdm/UpdateLicensepart', { params: params4 }).toPromise().then(
      (data: any) => {
        var vmsg = data;
        this.BindLicensepartGrid();
        this.btnpartclear();
      }).catch((data: any) => {
        var vmsg = data;
        this.BindLicensepartGrid();
        this.btnpartclear();
      });
  }

  btnpartclear() {
    this.ItemNo = "";
    this.partsId = "0";
    this.PartName = "";
    this.ItemUnit = "";
    this.ItemUnitWeight = "";
    this.ItemUnitPrice = "";
    this.ItemQuantity = "";
    this.ItemUnitValue = "";
    this.isShownupdBtn = true;
    this.isShownadBtn = false;
  }

  UpdateLicenseInfo() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownActive = false;

    if (this.LicType == undefined || this.LicType == null || this.LicType == "" || this.LicType == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select License Type.";
      return false;
    }
    if (this.LicenseName == undefined || this.LicenseName == null || this.LicenseName == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Name.";
      return false;
    }
    if (this.LicenseNumber == undefined || this.LicenseNumber == null || this.LicenseNumber == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Number.";
      return false;
    }
    if (this.LicenseDate == undefined || this.LicenseDate == null || this.LicenseDate == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Date.";
      return false;
    }
    if (this.ValidFrom == undefined || this.ValidFrom == null || this.ValidFrom == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid From.";
      return false;
    }
    if (this.ValidTo == undefined || this.ValidTo == null || this.ValidTo == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid To.";
      return false;
    }
    if (this.ValidFrom > this.ValidTo) {
      this.isShownError = false;
      this.ErrorMsg = "Valid To Date Should be Geater Then or EqualTo Valid From Date.";
      return false;
    }
    if (this.LicCurrency == undefined || this.LicCurrency == null || this.LicCurrency == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Currency.";
      return false;
    }
    if (this.LicValue == undefined || this.LicValue == null || this.LicValue == "" || this.LicValue == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Value.";
      return false;
    }
    var vVal=this.LicValue;
    if(Number(vVal)<1){
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Valid Value.";
      return false;
    }
    // if(this.LicItems==undefined || this.LicItems==null || this.LicItems==[] || this.LicItems.length ==0)
    // {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Add Atleast One License Item.";
    //   return false;
    // }
    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    let params = new HttpParams();
    params = params.append('sType', this.LicType);
    params = params.append('sName', this.LicenseName);
    params = params.append('sNumber', this.LicenseNumber);
    params = params.append('dLicevseDate', this.LicenseDate);
    params = params.append('dValidFrom', this.ValidFrom);
    params = params.append('dValidTo', this.ValidTo);
    params = params.append('sCurrency', this.LicCurrency);
    params = params.append('dValue', this.LicValue);
    params = params.append('sDescription', this.Description);
    params = params.append('iLicInfoId', this.EditedlicenseId);
    params = params.append('sStatus', vStatus);
    debugger;
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/UpdateLicense', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Success") {
                   
          var licId = this.EditedlicenseId;
          var spliturl = this.surl;
          debugger;
          if (spliturl != undefined && spliturl != "") {
            let params3 = new HttpParams();
            params3 = params3.append('sLicencenseId', licId);
            params3 = params3.append('sfurl', spliturl);
            debugger;
            var value2 = this.http.get(environment.apiUrl + 'LicenseAdm/InsertLicenseDoc', { params: params3 }).toPromise().then(
              (data: any) => {
                this.isShownActive = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
                this.LicType = "0";
                this.LicenseName = "";
                this.LicenseNumber = "";
                this.LicenseDate = "";
                this.ValidFrom = "";
                this.ValidTo = "";
                this.LicCurrency = "";
                this.LicValue = "";
                this.Description = "";
                this.Status = true;
                this.isShownSuccess = false;
                this.myFiles = [];
                this.selects = [];
                this.LicItems = [];
                this.surl="";
                this.dataSourceItem = new MatTableDataSource(this.LicItems);
                this.dataSourceItem.data = this.LicItems;
                this.isShowndoclist = true;
                this.isShownSuccess = false;
                this.SuccessMsg = "License Updated.";
                this.BindLicenseGrid();
                return false;
              }).catch((data: any) => {
                debugger;
                this.isShownActive = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
                this.LicType = "0";
                this.LicenseName = "";
                this.LicenseNumber = "";
                this.LicenseDate = "";
                this.ValidFrom = "";
                this.ValidTo = "";
                this.LicCurrency = "";
                this.LicValue = "";
                this.Description = "";
                this.Status = true;
                this.myFiles = [];
                this.selects = [];
                this.LicItems = [];
                this.surl="";
                this.dataSourceItem = new MatTableDataSource(this.LicItems);
                this.dataSourceItem.data = this.LicItems;
                this.isShowndoclist = true;
                this.isShownSuccess = false;
                this.SuccessMsg = "License Updated.";
                this.BindLicenseGrid();
                return false;
              })
          }
          else {
            this.isShownActive = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
            this.LicType = "0";
            this.LicenseName = "";
            this.LicenseNumber = "";
            this.LicenseDate = "";
            this.ValidFrom = "";
            this.ValidTo = "";
            this.LicCurrency = "";
            this.LicValue = "";
            this.Description = "";
            this.Status = true;
            this.isShownSuccess = false;
            this.myFiles = [];
            this.selects = [];
            this.LicItems = [];
            this.surl="";
            this.dataSourceItem = new MatTableDataSource(this.LicItems);
            this.dataSourceItem.data = this.LicItems;
            this.isShowndoclist = true;
            this.SuccessMsg = "License Updated.";
            this.BindLicenseGrid();
            return false;
          }
       

        }
        else {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
      });      

  }


  ClearLicense() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    this.LicType = "";
    this.LicType = "0";
    this.LicenseName = "";
    this.LicenseNumber = "";
    this.LicenseDate = "";
    this.ValidFrom = "";
    this.ValidTo = "";
    this.LicCurrency = "";
    this.LicValue = "";
    this.Description = "";
    this.isShowndoclist = true;
    this.LicItems = "";
    this.ItemNo = "";
    this.partsId = "";
    this.PartName = "";
    this.ItemUnit = "";
    this.ItemUnitWeight = "";
    this.ItemUnitPrice = "";
    this.ItemQuantity = "";
    this.ItemUnitValue = "";
    this.myFiles = [];
    this.selects = [];
    this.LicItems = [];
    this.surl="";
    this.dataSourceItem = new MatTableDataSource(this.LicItems);
    this.dataSourceItem.data = this.LicItems;
    this.isShownupdBtn = true;
    this.isShownadBtn = false;
  }

  BindLicenseGrid() {
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/GetLicenseForGrid').toPromise().then(
      (data1: any) => {
        debugger;
        this.dataSource1 = new MatTableDataSource(data1);
        this.dataSource1.data = data1;
        this.dataSource1.paginator = this.paginator1;
        this.dataSource1.sort = this.sort1;
      });
  }

  BindLicensepartGrid() {
    var editedlicId = this.EditedlicenseId
    var value5 = this.http.get(environment.apiUrl + 'LicenseAdm/GetlicPartForEdit?licId=' + editedlicId).toPromise().then(
      (data1: any) => {
        debugger;
        this.dataSourceItem = new MatTableDataSource(data1);
        this.dataSourceItem.data = data1;
        this.dataSourceItem.paginator = this.tableItemPaginator;
        this.dataSourceItem.sort = this.tableItemSort;
      });
  }
  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceItem.filter = filterValue;
  }

  BindlicenseExport() {
    var value = this.http.get(environment.apiUrl + 'LicenseAdm/GetLicenseForExport').toPromise().then(
      (data: any) => {
        debugger;
        this.licenseExport = data;
      });
  }

  exportexcel(): void {
    // debugger;
    // /* table id is passed over here */
    // const workSheet = XLSX.utils.json_to_sheet(this.PartsExport);
    // const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    // /* generate workbook and add the worksheet */
    // const wb: XLSX.WorkBook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, workSheet, 'Parts');

    // /* save to file */
    // XLSX.writeFile(wb, "Parts.xlsx");

    let element = document.getElementById('tblHeader');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'License');

    /* save to file */
    XLSX.writeFile(wb, "License.xlsx");

  }

}
